const apiCalls = {
  loginUser: "auth/login",
  logoutUser: "auth/logout",
  loginChangePassword: "auth/loginChangePassword",
  MenuList: "menus",
  Settings: "settings",
  LocationImagePath: "uploads?uploadWhileCreate=true&uploadPath=location",
  ProfileImagePath: "uploads?uploadWhileCreate=true&uploadPath=employee",
  dashboard: "dashboard/counts",
  Uploads: "bulkuploadStatus",
  employees: "employees",
  myProperties: "myProperties",
  clients: "clients",
  searches: "myProperties",
  matchedProperties: "matchedProperties",
  savedSearches: "savedSearches",
  offices: "offices",
  agents: "agents",
  tickets: "tickets",
  recentMatchedProperties: "recentMatchedProperties",
  notes: "notes",
  showMatchedProperties: "myProperties",
  reminders: "reminders",
  toDoLists: "toDoLists",
  news: "news",
  favourites: "favourites",
  scheduleAppointments:"scheduleAppointments",
  slotsAvailability:"slotsAvailability",
  reverseProspect:"myProperties/reverseProspect/",
};

// {"loginUser":"auth/login","logoutUser":"auth/logout","loginChangePassword":"auth/loginChangePassword","MenuList":"menus","Settings":"settings","LocationImagePath":"uploads?uploadWhileCreate=true&uploadPath=location","ProfileImagePath":"uploads?uploadWhileCreate=true&uploadPath=employee","dashboard":"dashboard/counts","employee":"employees","employees":"employees","Uploads":"bulkuploadStatus"}

export default apiCalls;
